<template>
  <div class="mycourse safe-distance-top-header">
    <Header pageTitle="我的课程" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box">
        <div
          class="list-item"
          v-for="item in mycourseList"
          :key="item.id"
          @click="getCourseDetails(item.articleId, item.goodsId)"
        >
          <img class="img_left" v-lazy="$global.imgUrl + item.cover" alt="" />
          <p class="cent_right">{{ item.title }}</p>
        </div>
      </div>
    </van-list>
  </div>
</template>
  
  <script>
import Header from "@/views/mobileView/components/header";
export default {
  name: "mycourse",
  components: {
    Header,
  },
  data() {
    return {
      title: "我的课程",
      loading: false,
      finished: false,
      error: false,
      mycourseList: [],
      pageNo: 0,
      pageSize: 20,
    };
  },
  methods: {
    onLoad() {
      this.pageNo += 1;
      this.getCurriculumList();
    },
    async getCurriculumList() {
      this.loading = true;
      const res = await this.$apis.myServe.getCurriculumList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      if (res.resultCode == 200) {
        this.finished = res.data.list.length < 20;
        this.mycourseList.push(...res.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    getCourseDetails(id, goodsId) {
      this.$router.push({
        name: "courseDetails",
        query: {
          type: 9,
          id,
          goodsId,
        },
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.mycourse {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  .list-box {
    margin: 0 auto;
    padding: 0 12px;
    width: 94%;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .list-item {
      display: flex;
      margin-top: 15px;
      padding-bottom: 16px;
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: none;
      }
      .img_left {
        width: 130px;
        height: 73px;
        border-radius: 6px;
      }
      .cent_right {
        flex: 1;
        margin-left: 10px;
        line-height: 23px;
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        .van-progress__pivot {
          display: none;
        }
      }
    }
  }
}
</style>